import styles from "../Editor.module.scss";

const TableBlock = ({content = []}) => {
    if (!content.length) return null;

    return (
        <div className={styles.reTableContainer}>
            <table className={styles.reTable}>
                <tbody className={styles.reTbody}>
                    {content.map((tr, tr_i) => {
                        return (
                            <tr key={tr_i} className={styles.reTr}>
                                {tr.map((td, td_i) => {
                                    return (
                                        <td key={td_i} className={styles.reTd}>{td}</td>
                                    );
                                })}
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </div>
    );
}

export default TableBlock;
